// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f777d2a","455":"9617821e","977":"2af269b4"}[chunkId] + ".chunk.js";
};